import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  // Close the Services dropdown on outside click, Escape, or route change
  useEffect(() => {
    if (!servicesOpen) return;
    const close = (e) => {
      if (!e.target.closest('.nav-dropdown')) setServicesOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setServicesOpen(false);
    };
    document.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('click', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [servicesOpen]);

  useEffect(() => {
    setServicesOpen(false);
  }, [location.pathname]);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === '/') {
      const el = document.querySelector(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.querySelector(targetId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="nav-content">
          <div className="logo">
            <Link to="/">
              <img src="/DiscoDuckLogo.png" width="600" height="750" alt="Disco Duck Events" className="logo-image" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <ul className="nav-links">
            <li><a href="#home" onClick={(e) => handleNavClick(e, '#home')}>Home</a></li>
            <li><Link to="/about">About</Link></li>
            <li className="nav-dropdown">
              <button
                type="button"
                className="nav-dropdown-toggle"
                aria-expanded={servicesOpen}
                aria-haspopup="true"
                onClick={() => setServicesOpen(open => !open)}
              >
                Services <span className="nav-dropdown-caret" aria-hidden="true" />
              </button>
              <ul className={`nav-dropdown-menu${servicesOpen ? ' open' : ''}`}>
                <li><Link to="/retro-booth" onClick={() => setServicesOpen(false)}>Retro Booth</Link></li>
              </ul>
            </li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/gallery">Client Gallery</Link></li>
          </ul>

          {/* Hamburger Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
        </div>
      </nav>

      {/* Backdrop */}
      <div
        className={`mobile-menu-backdrop${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Drawer */}
      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <button
          className="mobile-menu-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        />
        <ul className="mobile-nav-links">
          <li><a href="#home" onClick={(e) => handleNavClick(e, '#home')}>Home</a></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
          <li className="mobile-nav-group">
            <span className="mobile-nav-group-label">Services</span>
            <ul>
              <li><Link to="/retro-booth" onClick={() => setMenuOpen(false)}>Retro Booth</Link></li>
            </ul>
          </li>
          <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
          <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>
          <li><Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link></li>
          <li><Link to="/gallery" onClick={() => setMenuOpen(false)}>Client Gallery</Link></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
